module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    createdTime: BD.attr('datetime', { readonly: true }),
    isSystemComment: BD.attr('boolean', { readonly: true }),
    authorUser: BD.belongsTo('Billy.User', { readonly: true }),
    message: BD.attr('string'),
    associations: BD.hasMany('Billy.CommentAssociation', 'comment', { isEmbedded: true })
})
